module.exports = __webpack_public_path__ + "img/132.3.58bd19c0.png";